var map = {
	"./slider1.jpg": 3348,
	"./slider10.jpg": 4302,
	"./slider11.jpg": 425,
	"./slider12.jpg": 6251,
	"./slider13.jpg": 1504,
	"./slider2.jpg": 9482,
	"./slider3.jpg": 637,
	"./slider4.jpg": 8681,
	"./slider5.jpg": 7062,
	"./slider6.jpg": 7524,
	"./slider7.jpg": 8532,
	"./slider8.jpg": 5096,
	"./slider9.jpg": 8545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5531;